<template>
  <v-flex xs12 sm12 md12>

    <v-text-field hide-details="" @blur="blurevents" :rules="rules" :tabindex="tabdeger" v-model="displayValue" :disabled="Boolean(aktif)" :label="etiket"
      :name="name"  :id="id" @focus="isInputActive=true">
    </v-text-field>

  </v-flex>


</template>

<script>
  export default {
    name: 'currency-input',
    data() {
      return {
        isInputActive: false
      }
    },
    props: ['value', 'tabindex', 'name', 'id', 'etiket', 'aktif', 'tabdeger','simge','rules'],
    computed: {
      displayValue: {
        get: function () {


        //  this.value = parseFloat(this.value)
          if (typeof (this.value) != 'number') {
            return 0
          }

          if (this.isInputActive) {
            return this.value.toString()
          } else {
            return this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,') + this.simge
          }

        },
        set: function (modifiedValue) {
          let newValue = parseFloat(modifiedValue)
          if (isNaN(newValue)) {
            newValue = 0
          }
          this.$emit('input', parseFloat(newValue))
        }
      }
    },
    methods: {
      blurevents(){
        this.$emit('odakkaybi',this.val)
    this.isInputActive=false
      },
      getsifir() {
        return 0;
      }
    }
  }
</script>

<style scoped>
</style>